import apiClient from '@/services/axios'

export async function get(venueId) {
  var response = await apiClient.get(process.env.VUE_APP_CRM_API_BASE_URL + '/VenueCampaigns/ByVenueId/' + venueId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get venue campaigns')
}
